import React, { useState, useEffect, useCallback } from "react";
import KickImage from 'Reuseables/KickImage';
import FlashSaleBanner from "../../../images/flashsalemobile1024.png";
import FlashSaleDesktop from "../../../images/flash-sale-banner.png";
import emptySneakerImg from "../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../images/emptyhandbags.png";
import moment from "moment";
import { connect } from "react-redux";
import classNames from "classnames";
import {
  getFlashSaleCollectionList,
  getFlashSaleSetting,
} from "../../../actions/productAction";
import Slider from "react-slick";
import {
  getCollectionProductBrands,
  getCollectionBrands,
  getProductBrandByFilter,
  getCollectionList,
} from "../../../actions/kafairAction";
import LifeStyle_Arrow_Next from "../../../images/arrow/lifestyle_n.png";
import LifeStyle_Arrow_Prev from "../../../images/arrow/lifestyle_p.png";
import Luxury_Arrow_Next from "../../../images/arrow/lux_n.png";
import Luxury_Arrow_Prev from "../../../images/arrow/lux_p.png";
import Sneakers_Arrow_Next from "../../../images/arrow/raffle_holiday___sneakers_n.png";
import Sneakers_Arrow_Prev from "../../../images/arrow/raffle_holiday___sneakers_p.png";
import StreetWear_Arrow_Next from "../../../images/arrow/streetwear_next.png";
import StreetWear_Arrow_Prev from "../../../images/arrow/streetwear_previous.png";
import { getCloudImageUrl, emptyImage } from "../../../utils";
import { TextRupiah } from "../../Text";
import Countdown from "react-countdown";
import { withRouter, history } from "react-router-dom";
import MagnifyingGlass from "../../../images/magnifying-glass.png";
import { Container } from "reactstrap";
import MissingShoes from "../../../images/dashboard-empty-state.png";
import ArrowDown from "../../../images/arrowsDown.png";
import { debounce, delay } from "lodash";
import SneakerLoadingSpinner from "../../Sneakers/SneakerLoadingSpinner";
import BlackLeftFilter from "../../../images/black-mii-left.png";
import BlackRightFilter from "../../../images/black-mii-right.png";
import styled from "styled-components";

function PreviousArrowFilter(props) {
  const { className, style, onClick, category } = props;
  const LeftArrrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      margin-left: 5px;
      width: 10px !important;
      height: 10px !important;
      object-fit: contain;
      border-radius: 30px;
      margin-bottom: 15px;
    }

    @media (max-width: 480px) {
      img {
        width: 20px !important;
        height: 20px !important;
        position: absolute;
        left: -36px;
      }
    }
  `;
  const LeftSliderIcon = () => {
    switch (category) {
      case "sneakers":
        return Sneakers_Arrow_Prev;
      case "lifestyles":
        return LifeStyle_Arrow_Prev;
      case "handbags":
        return Luxury_Arrow_Prev;
      case "apparels":
        return StreetWear_Arrow_Prev;
      default:
        return Sneakers_Arrow_Prev;
    }
  };
  return (
    <LeftArrrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage
        src={BlackLeftFilter}
        alt="..."
        className="slider-arrow arrow-left"
      />
    </LeftArrrow>
  );
}

function NextArrowFilter(props) {
  const { className, style, onClick, category } = props;
  const RightArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      margin-left: 5px;
      width: 10px !important;
      height: 10px !important;
      object-fit: contain;
      border-radius: 30px;
      margin-bottom: 15px;
    }

    @media (max-width: 480px) {
      img {
        width: 20px !important;
        height: 20px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  const RightSliderIcon = () => {
    switch (category) {
      case "sneakers":
        return Sneakers_Arrow_Next;
      case "lifestyles":
        return LifeStyle_Arrow_Next;
      case "handbags":
        return Luxury_Arrow_Next;
      case "apparels":
        return StreetWear_Arrow_Next;
      default:
        return Sneakers_Arrow_Next;
    }
  };
  return (
    <RightArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage
        src={BlackRightFilter}
        alt="..."
        className="slider-arrow arrow-right"
      />
    </RightArrow>
  );
}

const filterSettings = {
  arrows: true,
  // autoplay:true,
  infinite: true,
  speed: 500,
  slidesToShow: 7,
  slidesToScroll: 7,
  lazyLoad: false,
  dots: false,
  swipe: false,
  prevArrow: <PreviousArrowFilter />,
  nextArrow: <NextArrowFilter />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};

const renderer = ({ days, hours, minutes, seconds, completed, ...props }) => {
  // const newHours = days * 24 + hours;
  return (
    <span style={{ color: "#fec350", fontFamily: "Nunito Bold" }}>
      {days < 10 ? `0${days}` : days}
      <span
        style={{
          fontSize: "10px",
          fontFamily: "Nunito Regular",
          color: "#242424",
        }}
      >
        {" "}
        days
      </span>{" "}
      {hours < 10 ? `0${hours}` : hours}
      <span
        style={{
          fontSize: "10px",
          fontFamily: "Nunito Regular",
          color: "#242424",
        }}
      >
        {" "}
        hours
      </span>{" "}
      {minutes < 10 ? `0${minutes}` : minutes}
      <span
        style={{
          fontSize: "10px",
          fontFamily: "Nunito Regular",
          color: "#242424",
        }}
      >
        {" "}
        minutes
      </span>{" "}
      {seconds < 10 ? `0${seconds}` : seconds}
      <span
        style={{
          fontSize: "10px",
          fontFamily: "Nunito Regular",
          color: "#242424",
        }}
      >
        {" "}
        seconds
      </span>
    </span>
  );
};

const styleDrawer = {
  borderRadius: "3px",
  marginTop: "8px",
  zIndex: 700,
  backgroundColor: "#fff",
  position: "absolute",
  width: "140px",
  border: "1px solid #ddd",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.16)",
};

const styleTextBold = {
  fontSize: "12px",
  fontFamily: "Nunito Bold",
  margin: "8px",
};

const styleTextNormal = {
  fontSize: "12px",
  fontFamily: "Nunito Regular",
  margin: "8px",
};

const styleOption = {
  height: "40%",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
};

const sort = [
  {
    id: 1,
    name: "Latest",
    value: "latest",
  },
  {
    id: 2,
    name: "Lowest Price",
    value: "price_asc",
  },
  {
    id: 3,
    name: "Highest Price",
    value: "price_desc",
  },
];

const PER_PAGE = 16;

function MadeInIndonesiaDetailPage({
  dataCategory,
  getCollectionProductBrands,
  history,
  getFlashSaleCollectionList,
  getFlashSaleSetting,
  getProductBrandByFilter,
  getCollectionBrands,
  localBrands,
  getCollectionList,
  location
}) {
  const [data, setData] = useState([]);

  /* temporaryData dipakai sebagai params useEffect untuk fungsi load more agar tidak perlu merubah redux */
  const [temporaryData, setTemporaryData] = useState([]);

  const [selectedSort, setSelectedSort] = useState("Lowest Price");
  const [searchInputAsParameter, setSearchInputAsParameter] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [openSortDrawer, setOpenSortDrawer] = useState(false);
  const [banner, setBanner] = useState({});
  const [page, setPage] = useState(1);
  const [previousPage, setPreviousPage] = useState([]);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [localBrandsList, setLocalBrandsList] = useState([]);
  const [selectedCurrentBrand, setSelectedCurrentBrand] = useState(null);
  const [windowHeight, setWindowHeight] = useState(0)
  const [hoveredSort, setHoveredSort] = useState("")
  const [isScrolling, setIscrolling] = useState(false)

  const searchHandler = useCallback(
    debounce((payload, string) => {
      submitSearch(payload, string);
    }, 1500),
    []
  );

  const loadMoreHandler = useCallback(
    debounce((payload, string) => {
      submitSearch(payload, string);
    }, 100),
    []
  );

  // DEFAULT PARAMETERS
  const defaultCategory = "all";
  const defaultSlug = "local-brands";
  const defaultStringName = "local_brands";
  const defaultPayload = {
    collection: "local-brands",
    collection_type: "brands",
    page: 1,
    availables: true,
    per_page: 16,
    keyword: "",
    sort_by: sortParams(selectedSort),
    brands: null,
  };

  /* USE EFFECTS */
  useEffect(() => {
    const { selectedCurrentBrand } = history.location.state || {};
    const brandSplit = history.location.search.includes("brand=") ? history.location.search.split("=") : [];
    const brandParams = brandSplit.length >= 1 ? brandSplit[1] : null;
    setLoading(true);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    /* GET INITIAL PRODUCTS */
    let payload = defaultPayload;
    if (brandParams) {
      // SET ADDTIONAL PAYLOAD

      payload = {
        ...payload,
        brands: brandParams,
      };
      setSelectedCurrentBrand(brandParams);
      submitSearch(payload);
    } else {
      submitSearch(defaultPayload);
    }

    /* GET BANNER */
    getCollectionList(defaultCategory, defaultSlug, {}, defaultStringName).then(
      ({ value: { data } }) => {
        const { categories = [] } = data || {};
        const currentEventCategory =
          categories.length > 0 &&
          categories.filter((category) => category.name === "bca");
        const { pivot = {} } = currentEventCategory[0] || {};
        setBanner(pivot.images || {});
      }
    );

    /* GET BRANDS LIST */
    getCollectionBrands(
      {
        page: 1,
        per_page: 100,
      },
      "local-brands"
    );
  }, []);

  useEffect(() => {
    const { data = [] } = localBrands.brands || {};
    if (data) {
      setLocalBrandsList([{ name: "All" }, ...data]);
    }
  }, [localBrands.brands]);

  useEffect(() => {
    setData(page === 1 ? temporaryData : [...data, ...temporaryData]);
  }, [temporaryData]);

  useEffect(() => {
    const { hasMoreData } = localBrands.products;
    hasMoreData
      ? document.addEventListener("scroll", trackScrolling)
      : document.removeEventListener("scroll", trackScrolling);
  }, [localBrands.products]);

  useEffect(() => {
    if (isScrolling) {
      setTimeout(() => {
        handlePageShow();
      }, 1000)
    }
  }, [isScrolling])

  useEffect(() => {
    if (location.search) {
      const brandSplit = location.search.includes("brand=") ? location.search.split("=") : [];
      const brandParams = brandSplit.length >= 1 ? brandSplit[1] : null;

      setSelectedCurrentBrand(brandParams);
      submitSearch({
        ...defaultPayload,
        brands: brandParams,
        sort_by: sortParams(selectedSort)
      });
    }
  }, [location])

  function submitSearch(payload) {
    setLoading(true);
    setIscrolling(false);
    getCollectionProductBrands(payload, defaultStringName)
      .then(({ value }) => {
        setLoading(false);
        if (!value.data.next_page_url) {
          setShowLoadMore(false);
        } else {
          setShowLoadMore(true);
        }
        window.scrollTo({
          bottom: windowHeight,
          behavior: "smooth",
        });
        setNoData(false);
        setTemporaryData(value.data.data);
      })
      .catch((e) => {
        setPage(1);
        setNoData(true);
        setLoading(false);
        setShowLoadMore(false);
      });
  }

  function handleSearchInput(e) {
    setSearchInput(e.target.value);
    setSearchInputAsParameter(e.target.value);
    setPage(1);
    setShowLoadMore(true);
    searchHandler({
      ...defaultPayload,
      sort_by: sortParams(selectedSort),
      keyword: e.target.value,
      brands: selectedCurrentBrand ? selectedCurrentBrand : null,
    });
  }

  function handleSortChange(value) {
    setSelectedSort(value);
    setPage(1);
    setShowLoadMore(true);
    submitSearch({
      ...defaultPayload,
      sort_by: sortParams(value),
      keyword: searchInputAsParameter,
      brands: selectedCurrentBrand ? selectedCurrentBrand : null,
    });
  }

  function goToProductPage(id, slug, categoryData) {
    const categoryUrl =
      categoryData === "apparels" || categoryData === "Apparels"
        ? "apparel"
        : categoryData === "lifestyles"
          ? "electronics-collectibles"
          : categoryData === "handbags"
            ? "luxury"
            : categoryData;

    window.location.href = `/${categoryUrl}/${id}/${slug}`;
  }

  function sortParams(sortName) {
    return sortName ? sort.find((item) => item.name === sortName).value : "";
  }

  function handlePageShow() {
    loadMoreHandler({
      ...defaultPayload,
      sort_by: sortParams(selectedSort),
      brands: selectedCurrentBrand ? selectedCurrentBrand : null,
      page: page + 1,
      keyword: searchInputAsParameter,
    });
    setPage(page + 1);
  }

  const isBottom = (el) => {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  };

  const trackScrolling = async () => {
    const { isFetching, hasMoreData } = localBrands.products;
    if (isFetching || !hasMoreData) return;
    const wrappedElement = document.getElementById("load-more-button");
    if (wrappedElement && isBottom(wrappedElement)) {
      document.removeEventListener("scroll", trackScrolling);
      setWindowHeight(wrappedElement.getBoundingClientRect().bottom);
      setIscrolling(true);
    }
  };

  const bannerImage =
    banner.length > 0 &&
    banner.filter((img) =>
      window.screen.availWidth > 480
        ? img.orientation === "landscape"
        : img.orientation === "portrait"
    );

  if (localBrandsList.length <= 1) return null

  return (
    <div id="made-in-indonesia-product-list-page"
      onClick={openSortDrawer ? () => setOpenSortDrawer(false) : null}
    >
      {bannerImage.length > 0 ? (
        <div className="made-in-indonesia-banner">
          <KickImage src={bannerImage[0].URL} alt="made-in-indonesia" />
        </div>
      ) : null}

      <Container>
        <div className="made-in-indonesia-widget">
          <div className="made-in-indonesia-filter">
            <div
              onClick={() => setOpenSortDrawer(!openSortDrawer)}
              className="fs-sort"
            >
              <h4>
                <span>Sort</span>
              </h4>
              <KickImage
                style={{ width: "10px", height: "auto", marginLeft: "5px" }}
                src={ArrowDown}
                alt="arrow down"
              />
            </div>
            {openSortDrawer && (
              <div style={styleDrawer} className="open-sort-drawer">
                {sort &&
                  sort.map((item) => {
                    return (
                      <div
                        style={styleOption}
                        key={item.id}
                        className="sort-option"
                        onClick={() => {
                          handleSortChange(item.name);
                          setOpenSortDrawer(!openSortDrawer);
                        }}
                      >
                        <h4
                          onMouseLeave={() => setHoveredSort("")}
                          onMouseEnter={() => setHoveredSort(item.name)}
                          style={
                            selectedSort === item.name || hoveredSort === item.name
                              ? styleTextBold
                              : styleTextNormal
                          }
                        >
                          {item.name}
                        </h4>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
          <div className="made-in-indonesia-search">
            <div className="fs-search-bar">
              <KickImage src={MagnifyingGlass} alt="magnifying glass" />
              <input
                value={searchInput}
                type="text"
                onChange={handleSearchInput}
                placeholder="Search"
              />
            </div>
          </div>
        </div>
        {window.screen.availWidth > 480 ? (
          <div className="made-in-indonesia-brand-list">
            <div className="brand-list-scroll-wrapper">
              <Slider {...filterSettings}>
                {localBrandsList.length > 0 &&
                  localBrandsList.map((brand, index) => {
                    let isActive = (() => {
                      if (selectedCurrentBrand == brand.id)
                        return "active";
                      if (!selectedCurrentBrand && index === 0) return "active";
                      return "";
                    })();

                    return (
                      <div
                        key={brand.id}
                        onClick={() => {
                          setPage(1);
                          setSearchInputAsParameter("");
                          if (brand.name === "All") {
                            setSelectedCurrentBrand(null);
                            submitSearch({
                              ...defaultPayload,
                              sort_by: sortParams(selectedSort),
                            });
                          } else {
                            // setSelectedCurrentBrand(brand.id);
                            // submitSearch({
                            //   ...defaultPayload,
                            //   brands: brand.id,
                            //   sort_by: sortParams(selectedSort),
                            // });
                            history.push(`/bcaxkickavenue/${defaultSlug}?brand=${brand.id}`)
                          }
                        }}
                        className="local-brands-wrapper"
                        style={{ textAlign: "center", cursor: "pointer" }}
                      >
                        <p className={`${isActive}`}>{brand.name}</p>
                      </div>
                    );
                  })}
              </Slider>
            </div>
          </div>
        ) : (
          <div
            style={{ overflow: "auto" }}
            className="made-in-indonesia-brand-list"
          >
            <div className="brand-list-scroll-wrapper">
              {localBrandsList.length > 1 &&
                localBrandsList.map((brand, index) => {
                  let isActive = (() => {
                    if (
                      selectedCurrentBrand == brand.id
                    )
                      return "active";
                    if (!selectedCurrentBrand && index === 0) return "active";
                    return "";
                  })();

                  return (
                    <div
                      key={brand.id}
                      onClick={() => {
                        setPage(1);
                        setSearchInputAsParameter("");
                        if (brand.name === "All") {
                          setSelectedCurrentBrand(null);
                          submitSearch({
                            ...defaultPayload,
                            sort_by: sortParams(selectedSort),
                          });
                        } else {
                          // setSelectedCurrentBrand(brand.id);
                          // submitSearch({
                          //   ...defaultPayload,
                          //   brands: brand.id,
                          //   sort_by: sortParams(selectedSort),
                          // });
                          history.push(`/bcaxkickavenue/${defaultSlug}?brand=${brand.id}`)
                        }
                      }}
                      className="local-brands-wrapper"
                      style={{ marginLeft: "20px" }}
                    >
                      <p className={`${isActive}`}>{brand && brand.name}</p>
                    </div>
                  );
                })}
            </div>
          </div>
        )}

        <>
          <div className="made-in-indonesia-content">
            {data && !noData ? (
              data.map((item) => {
                const categoryUrl =
                  item.product.category.name === "apparels" || item.product.category.name === "Apparels"
                    ? "apparel"
                    : item.product.category.name === "lifestyles"
                      ? "electronics-collectibles"
                      : item.product.category.name === "handbags"
                        ? "luxury"
                        : item.product.category.name;

                return (
                  <a href={`/${categoryUrl}/${item.id}/${item.slug}`} className="fs-product-wrapper" style={{ cursor: "pointer" }}>
                    <div
                      onClick={
                        item.price > 0 || !item.out_of_stock
                          ? () => goToProductPage(item.slug, item.id, item.product.category.name)
                          : null
                      }
                      className={classNames("fs-product", {
                        disabled: item.price <= 0 || item.out_of_stock,
                      })}
                      key={item.id}
                    >
                      <p
                        className={classNames({
                          disabled: item.price <= 0 || item.out_of_stock,
                        })}
                      >
                        {item.product.brand ? item.product.brand.flat.length > 0 && item.product.brand.flat[0] : ""}
                      </p>
                      <p
                        className={classNames({
                          disabled: item.price <= 0 || item.out_of_stock,
                        })}
                        style={{
                          fontFamily: "Nunito Bold",
                          marginTop: window.screen.availWidth < 400 && "0px",
                          marginBottom: window.screen.availWidth < 400 && "0px",
                          height:
                            window.screen.availWidth < 480 ? "45px" : "45px",
                          width: "90%",
                        }}
                      >
                        {item.display_name}
                      </p>
                      <KickImage
                        className={classNames({
                          disabled: item.price <= 0 || item.out_of_stock,
                        })}
                        src={
                          item.product_variant_images.length > 0 &&
                            new RegExp("\\b" + "s3.amazonaws.com" + "\\b").test(
                              item.product_variant_images[0].URL
                            )
                            ? getCloudImageUrl(
                              item.product_variant_images[0].URL,
                              400
                            )
                            : emptyImage(dataCategory)
                        }
                        alt={item.display_name}
                      />
                      <p
                        className={classNames({
                          disabled: item.price <= 0 || item.out_of_stock,
                        })}
                        style={{
                          fontFamily: "Nunito Bold",
                          marginTop:
                            window.screen.availWidth < 480 ? "45px" : "45px",
                          textAlign: "center",
                          width: "95%",
                          alignSelf: "center",
                        }}
                      >
                        {item.price > 0 ? (
                          <TextRupiah
                            prefix="IDR. "
                            color="black"
                            align="center"
                            value={item.price && item.price.toString()}
                            bold={true}
                          />
                        ) : (
                          "X"
                        )}
                      </p>
                    </div>
                  </a>
                );
              })
            ) : (
              <div style={{ width: "100vw" }}>
                <KickImage
                  style={{
                    width: window.screen.availWidth > 480 ? "40%" : "90%",
                    height: "auto",
                    margin:
                      window.screen.availWidth > 480
                        ? "20px 0px 20px 25%"
                        : "20px 0px 20px 2.5%",
                  }}
                  src={MissingShoes}
                  alt="no data"
                />
              </div>
            )}
          </div>
          {data.length > 0 && showLoadMore ? (
            <div
              style={{ width: "100%", backgroundColor: "transparent" }}
              id="load-more-button"
            />
          ) : null}
        </>
        {(localBrands.products.hasMoreData || showLoadMore) && (
          <div style={{ marginTop: "153px" }}>
            <SneakerLoadingSpinner isLoading={true} isHide={false} />
          </div>
        )}
      </Container>
    </div>
  );
}

const mapStateToProps = (state) => ({
  dataCategory: state.dataCategory.selected,
  localBrands: state.dataKaFair.local_brands,
});

const mapDispatchToProps = (dispatch) => ({
  getCollectionProductBrands: (category, slug, payload, name) =>
    dispatch(getCollectionProductBrands(category, slug, payload, name)),
  getFlashSaleCollectionList: (category, slug) =>
    dispatch(getFlashSaleCollectionList(category, slug)),
  getFlashSaleSetting: () => dispatch(getFlashSaleSetting()),
  getCollectionProductBrands: (payload, name) =>
    dispatch(getCollectionProductBrands(payload, name)),
  getCollectionBrands: (payload, slug) =>
    dispatch(getCollectionBrands(payload, slug)),
  getProductBrandByFilter: (payload) =>
    dispatch(getProductBrandByFilter(payload)),
  getCollectionList: (category, slug, payload, name) =>
    dispatch(getCollectionList(category, slug, payload, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MadeInIndonesiaDetailPage));
